import { groupTaskSteps } from "@/components/ui/task-steps-progress/groupTaskSteps";
import type { TaskStep } from "@/services/api/data-hub/types";

export type ItemGroupCounts = {
  done: number;
  failed: number;
  running: number;
  total: number;
};

export function countItemGroup(steps: TaskStep[]): ItemGroupCounts {
  let done = 0;
  let failed = 0;
  let running = 0;
  for (const step of steps) {
    if (step.status === "done") done += 1;
    else if (step.status === "failed") failed += 1;
    else if (step.status === "running" || step.status === "stalled") running += 1;
  }
  return { done, failed, running, total: steps.length };
}

export type ItemGroupTaskProgress = {
  processedCount: number;
  totalCount: number;
  failedCount: number;
  runningCount: number;
  percent: number;
  label: string;
};

type ItemGroupLabelCounts = {
  processedCount: number;
  total: number;
  failed: number;
};

/** Derive counts and label from a named phase step's item group (via {@link groupTaskSteps}). */
export function deriveItemGroupProgress(
  steps: TaskStep[],
  phaseTitle: string,
  labelBuilder: (counts: ItemGroupLabelCounts) => string,
): ItemGroupTaskProgress | null {
  const blocks = groupTaskSteps(steps);
  const group = blocks.find((block) => block.kind === "item-group" && block.title === phaseTitle);
  if (!group || group.kind !== "item-group") {
    return null;
  }

  const { done, failed, running, total } = countItemGroup(group.steps);
  if (total === 0) {
    return null;
  }

  const processedCount = done + failed;
  const percent = Math.round((processedCount / total) * 100);
  const label = labelBuilder({ processedCount, total, failed });

  return {
    processedCount,
    totalCount: total,
    failedCount: failed,
    runningCount: running,
    percent,
    label,
  };
}
